import Component from 'inferno-component';
import { Container, Grid, Menu, Modal } from 'semantic-ui-react';
import Prices from '../prices/Prices';
import Imprint from '../imprint/Imprint';

const style = {
  color: "white",
  cursor: "pointer"
}

export default class FooterLinks extends Component {
  render() {
    return (
      <Grid.Row centered>
        <Container>
          <Grid.Column>
            <Menu text compact width={3}>
              <Menu.Item>
                <Imprint />
              </Menu.Item>
              <Menu.Item>
                <a href="assets/files/ASZF.pdf" download="ASZF.pdf" style={style}>ÁSZF</a>
              </Menu.Item>
              <Menu.Item>
                <Modal trigger={<p style={style}>Listaárak</p>} closeIcon>
                  <Modal.Header>Listaárak</Modal.Header>
                  <Modal.Content scrolling>
                    <Prices />
                  </Modal.Content>
                </Modal>
              </Menu.Item>
            </Menu>
          </Grid.Column>
        </Container>
      </Grid.Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/FooterLinks.js